// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uzrJW","sub":"styles_sub__38rKs","topLabel":"styles_topLabel__SLtCG","topLabelVal":"styles_topLabelVal__6lEME"};